import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { eventsApi } from 'src/Services/API';
import { EventDto, CreateEventDto, EventDtoTypeEnum } from 'src/Services/API/generated';
import { trackEvent } from 'src/Services/Matomo';
import { trackMixpanelEvent } from 'src/Services/Mixpanel';
import { ApiError } from 'src/types/api-error.types';

export const useCreateEvent = (
  options?: UseMutationOptions<EventDto, ApiError, CreateEventDto>
) => {
  const queryClient = useQueryClient();
  const assetId = useCurrentAssetId();

  return useMutation<EventDto, ApiError, CreateEventDto>(
    ['create-event', assetId],
    async data => {
      if (!assetId) {
        throw new Error('No asset selected');
      }

      const response = await eventsApi.eventsControllerCreate(assetId, data);
      return response.data;
    },
    {
      ...options,
      onSuccess: (data: EventDto, variables: CreateEventDto, context: unknown) => {
        queryClient.invalidateQueries({ queryKey: ['fetch-events'] });
        trackEvent('Planning', 'create', data.name);
        if (variables.type === EventDtoTypeEnum.Occupation) {
          trackMixpanelEvent('occupation_period_created', {
            from_household: (variables.householdIds?.length ?? 0) > 0,
            households_count: variables.householdIds?.length ?? 0,
          });
        }
        if (options?.onSuccess) {
          options.onSuccess(data, variables, context);
        }
      },
    }
  );
};
